/* Teams & Events: links marked data-tappd-topic scroll to the enquiry form
   (their href does that) and preselect the matching topic in its dropdown. */
(function () {
  if (window.tappdTeams) return;
  window.tappdTeams = true;

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-tappd-topic]');
    if (!link) return;
    var select = document.querySelector('[data-tappd-topic-select]');
    if (!select) return;
    var option = select.querySelector('option[data-topic="' + link.dataset.tappdTopic + '"]');
    if (option) select.value = option.value;
  });

  /* ---------- full-size viewer for the hero mosaic ----------
     The slides are the mosaic tiles in page order, so a tile added there is in
     the viewer too. The reel's slide plays it from the start, with sound and
     controls; it stops when the viewer moves on or closes. <dialog> gives
     Esc-to-close and keeps focus inside while it's open. */
  var box = document.querySelector('[data-te-viewer]');
  if (!box) return;
  var img = box.querySelector('[data-te-img]');
  var vid = box.querySelector('[data-te-vid]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var index = 0;

  function tiles() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-te-tile]'));
  }
  /* the muted reel in the mosaic rests while the viewer is open */
  function tileVideo() {
    return document.querySelector('[data-te-tile] video');
  }

  function show() {
    var list = tiles();
    index = (index + list.length) % list.length;
    var tile = list[index];
    var cap = tile.querySelector('.tappd-tmcap');
    if (tile.dataset.teVideo) {
      img.hidden = true;
      vid.hidden = false;
      if (vid.getAttribute('src') !== tile.dataset.teVideo) vid.src = tile.dataset.teVideo;
      vid.setAttribute('aria-label', tile.dataset.teAlt || '');
      vid.muted = false;
      vid.currentTime = 0;
      vid.play().catch(function () {});
    } else {
      vid.pause();
      vid.hidden = true;
      img.hidden = false;
      img.src = tile.dataset.teFull || '';
      img.alt = tile.dataset.teAlt || '';
    }
    box.querySelector('[data-te-title]').textContent = cap ? cap.querySelector('b').textContent : '';
    box.querySelector('[data-te-sub]').textContent = cap ? cap.querySelector('span').textContent : '';
    box.querySelector('[data-te-count]').textContent = index + 1 + ' of ' + list.length;
  }

  function open(i) {
    index = i;
    var t = tileVideo();
    if (t) t.pause();
    show();
    if (box.showModal) box.showModal();
    else box.setAttribute('open', '');
  }
  function close() {
    if (box.close) box.close();
    else box.removeAttribute('open');
  }
  box.addEventListener('close', function () {
    vid.pause();
    var t = tileVideo();
    if (t && !reduceMotion.matches) t.play().catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-te-tile]');
    if (tile) {
      open(tiles().indexOf(tile));
      return;
    }
    if (e.target === box || e.target.closest('[data-te-close]')) {
      close();
      return;
    }
    var step = e.target.closest('[data-te-step]');
    if (step) {
      index += parseInt(step.dataset.teStep, 10);
      show();
    }
  });
  box.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); index += 1; show(); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); index -= 1; show(); }
  });
})();
